import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import classNames from 'clsx';
import Config from '~/config';
import { device } from '~/utils';
import withI18next from '~/../hocs/_withI18next';
import themeVariables from '~/shared/themeVariables';

@withI18next()
class ButtonCopyLink extends React.Component {
  state = {
    showCopySuccess: false,
  };

  handleCopy = () => {
    this.setState({ showCopySuccess: true });
    const text = window.location.href;
    if (window.navigator && window.navigator.clipboard) {
      navigator.clipboard.writeText(text);
    } else {
      device.copyToClipboard(text);
    }
  };

  render() {
    const { showCopySuccess } = this.state;
    const { t, className, isFromDownloadPage } = this.props;
    const buttonClassName = classNames(
      'btn',
      showCopySuccess ? 'btn-ac-primary' : 'btn-ac-primary-outline',
      'btn-block btn-copy-link',
      className,
      `btn-${Config.serviceType}`,
    );
    return (
      <>
        {Config.isIllustAC() && isFromDownloadPage ? (
          <button
            className="btn-copy-link-image-download"
            onClick={this.handleCopy}
          >
            {showCopySuccess ? t('copied') : t('copy_link')}
          </button>
        ) : (
          <button className={buttonClassName} onClick={this.handleCopy}>
            <FontAwesomeIcon
              style={{ width: '1em' }}
              icon={showCopySuccess ? faCheck : faCopy}
              className="icon-copy"
            />
            {t('copy_link')}
          </button>
        )}
        <style jsx global>
          {`
            .btn-copy-link {
              margin-top: 7px;
            }
            .btn-copy-link .icon-copy {
              margin-right: 7px;
            }
            .btn-copy-link-image-download {
              padding: 8px 16px;
              width: 96px;
              height: 32px;
              background: #170507;
              border-radius: 40px;
              display: flex;
              justify-content: center;
              align-items: center;
              margin: 0;
              font-weight: 700;
              font-size: 14px;
              line-height: 16px;
              color: #ffffff;
              border: none;
              white-space: nowrap;
            }
            .btn-copy-link-image-download:hover {
              background-color: ${themeVariables.colors.primary};
            }
          `}
        </style>
      </>
    );
  }
}
export default ButtonCopyLink;
